import React from 'react';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 04/04/18
 */

import styles from './styles.css';

const Indonesia = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <p>
        <center>
          <b>BAGIAN PERTAMA TENTANG SYARAT DAN KETENTUAN UMUM</b>
        </center>
      </p>
      <p>
        <b>PASAL 1: DEFINISI</b>
      </p>
      <p>
        Kecuali secara tegas ditentukan lain dalam hubungan kalimat di dalam
        Ketentuan ini, istilah-istilah yang digunakan dalam Ketentuan ini
        mempunyai arti sebagai berikut:
      </p>
      <ol type="1">
        <li>
          ”Bukti Pembayaran” adalah tanda terima atau bukti pembayaran yang
          dinyatakan sah oleh Para Pihak dengan identifikasi Nomor Referensi.
        </li>
        <li>
          “Biaya Sewa” adalah nominal yang dibayarkan MERCHANT kepada TELKOMSEL
          atas penggunaan EDC setiap bulannya.
        </li>
        <li>
          “Electronic Data Capture (EDC)” adalah terminal atau peralatan khusus
          yang umumnya digunakan di MERCHANT yang berfungsi untuk membaca dan
          memproses data elektronis dari TCASH, melakukan autorisasi dan
          validasi transaksi pembayaran.
        </li>
        <li>
          “Fee” adalah nilai nominal yang harus dibayarkan oleh MERCHANT ke
          TELKOMSEL setiap menerima Transaksi dengan menggunakan layanan TCASH.
        </li>
        <li>
          “Formulir Aplikasi MERCHANT” adalah formulir berisi data diri MERCHANT
          dan kesepakatan terkait kerjasama ini dan merupakan bagian tak
          terpisahkan dari Ketentuan.
        </li>
        <li>
          “Host TELKOMSEL” adalah pusat komputer TELKOMSEL yang berfungsi untuk
          menerima dan memproses Transaksi, yang mana harus memenuhi standar
          format message yang disepakati oleh MERCHANT dan TELKOMSEL.
        </li>
        <li>
          “Laporan” adalah Informasi yang dapat berupa data-data dan bukti
          tertulis lainnya yang diberikan terkait dengan pelaksanaan transaksi
          pembayaran pada MERCHANT menggunakan layanan TCASH untuk 1 (satu)
          bulan kalender.
        </li>
        <li>
          “MERCHANT Discount Rate (MDR)” adalah nominal yang dibayarkan MERCHANT
          kepada TELKOMSEL untuk setiap transaksi berhasil yang menjadi komponen
          dari Fee.
        </li>
        <li>
          “Pedagang (MERCHANT)” adalah penjual barang dan/atau jasa yang
          menerima transaksi pembayaran dari Pengguna.
        </li>
        <li>
          ”Pengguna” adalah individu yang menggunakan TCASH dan hendak melakukan
          Transaksi dengan MERCHANT.
        </li>
        <li>
          “Ketentuan Kerjasama Layanan Pembayaran MERCHANT TCASH (Ketentuan)”
          adalah dokumen perikatan antara TELKOMSEL dan MERCHANT yang terdiri
          dari Formulir Aplikasi MERCHANT dan Ketentuan kerjasama ini yang
          seluruhnya merupakan bagian tak terpisahkan.
        </li>
        <li>
          “Produk MERCHANT” adalah produk yang dimiliki oleh MERCHANT untuk
          dapat dibayarkan oleh Pengguna melalui layanan TCASH milik TELKOMSEL.
        </li>
        <li>
          ”Rekonsiliasi” adalah proses penyesuaian Laporan yang dimiliki oleh
          Para Pihak berdasarkan bentuk dan mekanisme yang telah disepakati.
        </li>
        <li>
          “Transaksi” adalah proses penerimaan pembayaran/pembelian yang
          dilakukan oleh Pengguna melalui layanan TCASH di fasilitas MERCHANT.
        </li>
        <li>
          “Transaksi Berhasil” adalah Transaksi yang dinyatakan disetujui oleh
          TELKOMSEL dalam pelaksanakan pembayaran di MERCHANT menggunakan
          layanan TCASH.
        </li>
        <li>
          ”TCASH” adalah layanan uang elektronik yang diselenggarakan oleh
          TELKOMSEL yang telah terdaftar dan diawasi oleh Bank Indonesia,
          memiliki fungsi yang sama dengan uang tunai sebagai alat pembayaran
          sah, dimana nilainya setara dengan nilai uang tunai yang disetorkan
          terlebih dahulu ke rekening TCASH Pengguna, tercatat secara elektronik
          di dalam server milik TELKOMSEL, digunakan sebagai alat pembayaran
          kepada pedagang selain TELKOMSEL, dan uang yang disetorkan bukan
          bersifat simpanan sebagaimana diatur dalam peraturan
          perundang-undangan perbankan.
        </li>
      </ol>
      <p>
        <b>PASAL 2: RUANG LINGKUP</b>
      </p>
      <ol type="1">
        <li>
          Para Pihak sepakat untuk melakukan kerjasama pelaksanaan penerimaan
          pembayaran pembelian jasa atau produk di MERCHANT melalui layanan
          TCASH.
        </li>
        <li>
          Dalam pelaksanaan kerjasama sebagaimana tersebut dalam ayat (1) Pasal
          ini, TELKOMSEL akan bertindak sebagai penerbit uang elektronik TCASH,
          dan MERCHANT akan bertindak sebagai penyedia dan penanggung jawab
          produk dan jasa yang dijual MERCHANT.
        </li>
        <li>
          Sebagai pelaksanaan dari pola kerjasama sebagaimana dimaksud dalam
          ayat (2) Pasal ini, maka masing-masing Pihak akan mematuhi syarat dan
          ketentuan dalam Ketentuan pada umumnya, dan secara khusus yang
          terdapat dalam Bagian II Ketentuan mengenai syarat dan ketentuan
          MERCHANT.
        </li>
        <li>
          Para Pihak sepakat akan memperluas lingkup kerjasama yang tertuang
          dalam Ketentuan ini di kemudian hari, apabila terdapat pengembangan
          fungsi produk layanan TCASH.
        </li>
      </ol>
      <p>
        <b>PASAL 3: JANGKA WAKTU KERJASAMA</b>
      </p>
      <p>
        Ketentuan ini berlaku untuk Jangka Waktu Kerjasama sebagaimana
        ditetapkan dalam Formulir Aplikasi MERCHANT, terhitung sejak tanggal
        penandatanganan oleh Para Pihak, dan secara otomatis akan diperpanjang
        dengan sendirinya untuk jangka waktu 1 (satu) tahun berikutnya apabila
        tidak ada pemberitahuan pengakhiran sebagaimana diuraikan pada Pasal 14
        Ketentuan ini.{' '}
      </p>

      <p>
        <b>PASAL 4: PAJAK - PAJAK</b>
      </p>
      <p>
        <b>
          <i>Keberpatuhan terhadap Undang-Undang Perpajakan. </i>
        </b>
        Para Pihak memahami dan sepakat bahwa karena kegiatan di Indonesia atau
        karena mendapatkan penghasilan dari TELKOMSEL, MERCHANT dan TELKOMSEL
        akan bertanggung jawab untuk pembayaran pajak masing-masing dan/atau
        untuk persyaratan administratif yang berkaitan dengan pajak tersebut.
        MERCHANT dan TELKOMSEL akan bertanggung jawab dan membayar semua jenis
        pajak tepat waktu sesuai dengan ketentuan perpajakan yang berlaku.
      </p>

      <p>
        <b>PASAL 5 : BIAYA, TATA CARA PEMBAYARAN DAN SANKSI</b>
      </p>
      <ol type="1">
        <li>
          <b>
            <i>Biaya &amp; Tata Cara Pembayaran. </i>
          </b>
          Terhitung sejak ditandatanganinya Ketentuan ini, biaya yang menjadi
          hak TELKOMSEL yang akan dibayarkan oleh MERCHANT, akan dipotong
          langsung oleh TELKOMSEL dari nilai transaksi tersebut.
        </li>
        <li>
          Atas alasan dan dasar apapun, MERCHANT dan TELKOMSEL sepakat untuk
          tidak mengenakan biaya tambahan apapun dan dalam bentuk apapun kepada
          pengguna TCASH, selain biaya sebagaimana dirincikan dalam Formulir dan
          Ketentuan ini. Pelanggaran terhadap ketentuan Pasal ini dapat
          mengakibatkan diakhirinya Ketentuan sebagaimana diatur dalam Pasal 14
          Bagian I Ketentuan ini.
        </li>
        <li>
          Biaya transaksi dalam Ketentuan ini sudah termasuk PPN sesuai
          ketentuan pajak yang berlaku.
        </li>
        <li>
          Tata Cara Pembayaran transaksi :TELKOMSEL membayar bagian yang menjadi
          hak MERCHANT untuk setiap transaksi berhasil selambat-lambatnya 2
          (dua) hari kerja efektif setelah dikurangi Biaya Transaksi ke rekening
          MERCHANT sebagaimana tertuang dalam backoffice MERCHANT sebelum
          melakukan aktivasi.
        </li>
      </ol>

      <p>
        <b>PASAL 6 : LAPORAN, REKONSILIASI DAN EVALUASI</b>
      </p>
      <ol type="1">
        <li>
          <b>
            <i>Laporan. </i>
          </b>
          Para Pihak sepakat bahwa Laporan atas pelaksanaan traksaksi layanan
          TCASH yang menjadi kewajiban Para Pihak, didasarkan pada data
          Transaksi Berhasil setiap bulan yang dimiliki oleh TELKOMSEL.
        </li>
        <li>
          MERCHANT dari waktu ke waktu dapat melihat Laporan atas pelaksanaan
          transaksi layanan TCASH tersebut pada ayat (1) di atas, melalui sistem
          aplikasi MOKA yang tersedia di backoffice MERCHANT.
        </li>
        <li>
          Apabila terdapat perbedaan Laporan diantara Para Pihak, maka untuk
          selanjutnya Para Pihak sepakat akan mengadakan Rekonsiliasi
          selambat-lambatnya 5 (lima) hari kerja sejak ditemukan perbedaan
          Laporan sebagai upaya penyelesaian atas perbedaan dimaksud.
        </li>
        <li>
          <b>
            <i>Rekonsiliasi. </i>
          </b>
          Pelaksanaan Rekonsiliasi atas laporan yang dimiliki oleh Para Pihak
          akan dilaksanakan sesuai dengan kesepakatan Ketentuan ini.
        </li>
        <li>
          Jika dalam waktu 7 (tujuh) hari kerja sejak pelaksanaan Rekonsiliasi
          tidak tercapai kesepakatan diantara Para Pihak, maka untuk selanjutnya
          Para Pihak sepakat menggunakan data Laporan TELKOMSEL sebagai
          pembayaran terlebih dahulu, dimana sisa pembayaran atas periode bulan
          tersebut akan dilaksanakan dalam jangka waktu 5 (lima) hari kerja
          setelah Berita Acara Rekonsiliasi disepakati dan ditandatangani oleh
          Para Pihak.
        </li>
        <li>
          <b>
            <i>Evaluasi. </i>
          </b>
          Para Pihak sepakat untuk melakukan proses evaluasi Ketentuan baik
          sebagian maupun seluruhnya setiap 3 (tiga) bulan selama Jangka Waktu
          Kerjasama. Hasil evaluasi dapat dijadikan dasar untuk pembekuan atau
          pengakhiran kerjasama dimana hasil evaluasi tersebut dituangkan dalam
          Berita Acara Kesepakatan yang ditandatangani oleh Para Pihak.
        </li>
      </ol>
      <p>
        <b>PASAL 7 : PROMOSI</b>
      </p>
      <ol type="1">
        <li>
          Masing-masing Pihak berhak untuk menempatkan nama dan logo
          masing-masing pihak di media-media promosi dengan ketentuan bahwa Para
          Pihak wajib memberi informasi dan/atau permohonan berkenaan dengan
          penggunaan nama dan logo tersebut dan masing-masing Pihak wajib
          memberikan tanggapan dan/atau persetujuannya secara tertulis dalam
          waktu 14 (empat belas) Hari Kerja sesudah informasi dan/atau
          permohonan diterima oleh Pihak yang bersangkutan.
        </li>
        <li>
          Dalam melaksanakan kegiatan promosi, Para Pihak dapat mempergunakan
          nama dan logo pihak lainnya dengan persetujuan tertulis dari pihak
          yang nama dan logonya digunakan oleh Pihak lain tersebut,
          selambat-lambatnya 14 (empat belas) hari kalender sejak disampaikannya
          permohonan persetujuan. Dengan terlampauinya 14 (empat belas) hari
          kalender tersebut tanpa adanya persetujuan tertulis dari Pihak yang
          nama dan logonya dipergunakan, maka Pihak tersebut dianggap telah
          menyetujui pemakaian nama dan logonya dalam promosi tersebut.
        </li>
        <li>
          Materi dan promosi yang dilaksanakan oleh Para Pihak tunduk pada
          ketentuan perundangan yang berlaku dan jangka waktu penggunan logo
          Para Pihak oleh masing-masing Pihak dalam rangka promosi adalah selama
          masa berlakunya Ketentuan ini.
        </li>
        <li>
          Para Pihak sepakat bahwa biaya yang dikeluarkan oleh Para Pihak dalam
          rangka promosi sebagaimana diatur dalam pasal ini ditanggung oleh
          masing-masing Pihak.
        </li>
      </ol>

      <p>
        <b>PASAL 8 : PELAYANAN PENGGUNA</b>
      </p>
      <ol type="1">
        <li>
          Setiap pertanyaan dan keluhan Pengguna mengenai layanan TCASH milik
          TELKOMSEL dapat disampaikan kepada contact center milik TELKOMSEL di :
          <ol type="a">
            <li>Melalui Kantor Layanan TELKOMSEL GraPARI</li>
            <li>
              Melalui call centre TELKOMSEL dengan nomor akses 133 untuk
              KartuHALO dan 188 untuk kartu SimPATI dan AS (berbayar jika
              terhubung dengan CS) serta nomor akses Nasional nomor 08071811811
              (tarif lokal PSTN).
            </li>
          </ol>
        </li>
        <li>
          Penyelesaian pertanyaan dan keluhan Pengguna TCASH akan diselesaikan
          oleh TELKOMSEL sesuai dengan ketentuan yang dikeluarkannya dari waktu
          ke waktu.
        </li>
      </ol>

      <p>
        <b>PASAL 9 : PERNYATAAN DAN JAMINAN</b>
      </p>
      <ol type="1">
        <li>
          Para Pihak dengan ini saling menyatakan akan untuk melaksanakan isi
          Ketentuan ini dengan penuh tanggung jawab (profesional) dan atas dasar
          hubungan yang saling menguntungkan.
        </li>
        <li>
          TELKOMSEL dengan ini menjamin dan membebaskan MERCHANT dari segala
          keluhan, klaim, tuntutan dan atau kerugian dari Pengguna atau Pihak
          Ketiga manapun sehubungan dengan dan sejauh menyangkut tentang
          penyelenggaraan Jasa Telekomunikasi Selular dan penyelenggaraan
          layanan TCASH, sehingga apabila hal tersebut timbul sebagai akibat
          dari kesalahan TELKOMSEL, maka hal-hal demikian sepenuhnya menjadi
          risiko dan tanggung jawab TELKOMSEL.
        </li>
        <li>
          MERCHANT dengan ini menjamin dan membebaskan TELKOMSEL dari segala
          tuntutan dan/atau kerugian dari Pengguna atau pihak Ketiga manapun
          sehubungan dengan dan sejauh menyangkut tentang kinerja Mercant maupun
          mitra dari MERCHANT, sehubungan dengan jasa yang disediakan MERCHANT
          dalam Ketentuan ini, sehingga apabila hal tersebut timbul sebagai
          akibat dari kesalahan MERCHANT maupun mitra dari MERCHANT terkait
          penyediaan layanan TCASH sebagaimana diatur dalam Ketentuan ini, maka
          hal-hal demikian sepenuhnya menjadi risiko dan tanggung jawab
          MERCHANT.
        </li>
        <li>
          Para pihak dengan ini menyatakan dan menjamin bahwa Pihak-Pihak yang
          menandatangani Ketentuan ini adalah sah dan berwenang sesuai dengan
          ketentuan anggaran dasar perseroan yang diwakilinya dari dan karenanya
          Para Pihak saling membebaskan atas terjadinya tuntutan dari pihak lain
          mengenai penandatanganan Ketentuan ini.
        </li>
      </ol>
      <p>
        <b>PASAL 10 : HAK ATAS KEKAYAAN INTELEKTUAL (HAKI)</b>
      </p>
      <ol type="1">
        <li>
          Dalam rangka pelaksanaan Ketentuan ini, ketentuan-ketentuan sebagai
          berikut berlaku dalam kaitannya dengan HAKI:
          <ol type="a">
            <li>
              Selama jangka waktu Ketentuan ini, MERCHANT akan tetap memiliki
              seluruh HAKI atas (a) semua yang telah dimiliki oleh MERCHANT; dan
              (b) semua yang disediakan oleh MERCHANT agar layanan dapat
              disediakan kepada Pengguna;
            </li>
            <li>
              Tidak ada suatu ketentuan-pun dalam Ketentuan ini yang menyatakan
              bahwa MERCHANT mengesampingkan atau melepaskan HAKI yang
              dimilikinya sebagaimana dimaksud pada sub ayat a. di atas;
            </li>
            <li>
              TELKOMSEL akan tetap memiliki seluruh HAKI yang dimiliki oleh
              TELKOMSEL untuk keperluan pelaksanaan hal-hal yang diatur di dalam
              dan oleh Ketentuan ini;
            </li>
            <li>
              Tidak ada suatu ketentuan-pun dalam Ketentuan ini yang menyatakan
              bahwa TELKOMSEL mengesampingkan atau melepaskan HAKI yang
              dimilikinya sebagaimana dimaksud pada sub ayat c. di atas.
            </li>
          </ol>
        </li>
        <li>
          Para Pihak akan saling menjaga dan menghormati hal-hal yang berkenaan
          dengan HAKI ataupun HAKI yang timbul sebagai akibat dari pelaksanaan
          Ketentuan ini, sesuai ketentuan hukum yang berlaku.
        </li>
        <li>
          Para Pihak menyatakan dan menjamin bahwa HAKI yang dimiliki Para Pihak
          diperoleh secara sah dan dengan tidak melawan hukum dan oleh karena
          itu tidak akan melanggar atau bertentangan dengan ketentuan hukum yang
          berlaku maupun merugikan hak dan/atau kepentingan sah pihak lain.
        </li>
        <li>
          Istilah HAKI yang dimaksud di dalam Ketentuan ini mencakup, namun
          tidak terbatas pada, hak cipta, paten, merek dagang, merek layanan,
          rahasia dagang, desain industri, logo, dan hak-hak lain yang serupa
          sesuai dengan ketentuan hukum yang berlaku.
        </li>
      </ol>

      <p>
        <b>PASAL 11 : INFORMASI RAHASIA</b>
      </p>
      <ol type="1">
        <li>
          Para Pihak telah saling bersepakat dan setuju bahwa segala informasi
          dan keterangan baik yang tertulis maupun tidak tertulis serta
          informasi-informasi lain yang diperoleh Para Pihak berdasarkan
          Ketentuan ini adalah bersifat rahasia (selanjutnya disebut “Informasi
          Rahasia”) serta tidak boleh diberitahukan kepada pihak ketiga atau
          badan / orang yang tidak berkepentingan dengan alasan apapun.
          Ketentuan mengenai kerahasiaan ini tetap berlaku untuk jangka waktu 3
          (tiga) tahun terhitung sejak berakhirnya Ketentuan ini.
        </li>
        <li>
          Ketentuan kerahasiaan tersebut pada ayat (1) Pasal ini tidak berlaku
          apabila:
          <ol type="a">
            <li>
              Informasi Rahasia dimaksud telah dimiliki oleh pihak ketiga lain
              sebelum salah satu pihak menerima Informasi Rahasia dari pihak
              lainnya.
            </li>
            <li>
              Pihak pemberi Informasi Rahasia membocorkan atau menyebarluaskan
              Informasi Rahasia kepada Pihak lain setelah Pihak penerima
              informasi menerima Informasi Rahasia dimaksud.
            </li>
            <li>
              Pihak penerima Informasi Rahasia telah menerima Informasi Rahasia
              dari pihak ketiga lainnya, dimana pihak ketiga dimaksud menerima
              Informasi Rahasia secara sah tanpa melanggar hukum.
            </li>
            <li>
              Salah satu Pihak memberikan Informasi Rahasia kepada instansi
              pemerintah yang berwenang mengatur atau mengeluarkan ijin tentang
              hal-hal yang diperjanjikan dalam Ketentuan ini atas permintaan
              instansi pemerintah dimaksud.
            </li>
            <li>
              Salah satu Pihak memberikan Informasi Rahasia kepada pihak ketiga
              karena diperintahkan oleh badan peradilan atau instansi pemerintah
              lainnya yang berhubungan dengan penegakan hukum secara tertulis,
              resmi, dan merupakan putusan final.
            </li>
            <li>
              Salah satu Pihak memberikan Informasi Rahasia kepada pihak ketiga
              karena menurut peraturan perundang-undangan yang berlaku di
              Indonesia, informasi tersebut harus diberikan kepada pihak lain
              yang disebut secara jelas dalam peraturan perundang-undangan
              tersebut.
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <b>PASAL 12: PEMBATASAN TANGGUNG JAWAB</b>
      </p>
      <p>
        Tanggung jawab MERCHANT kepada TELKOMSEL atas pelaksanaan Ketentuan ini
        adalah terbatas pada dan tidak melebihi nilai total Fee dan Biaya Sewa
        selama jangka waktu Ketentuan, dengan ketentuan pembatasan tersebut
        tidak berlaku dalam hal terjadi salah satu atau lebih hal-hal berikut
        ini yang disebabkan oleh kesalahan pihak MERCHANT: (i) kesalahan yang
        disengaja (<i>willful misconduct</i>) (ii) kelalaian yang sangat besar (
        <i>gross negligence</i>) (iii) luka badan (iv) hilangnya nyawa orang,
        dan (v) pelanggaran hak atas kekayaan intelektual.
      </p>
      <p>
        <b>PASAL 13 : INDEMNIFIKASI</b>
      </p>
      <p>
        MERCHANT bertanggungjawab untuk dan wajib mengganti kerugian,
        melindungi, serta membebaskan TELKOMSEL, dari dan atas setiap klaim,
        tuntutan biaya-biaya, pembayaran-pembayaran dan pengeluaran-pengeluaran
        dari pihak ketiga lainnya sehubungan dengan setiap kerugian yang timbul
        sebagai akibat dari cidera janji MERCHANT berdasarkan Ketentuan ini.
      </p>
      <p>
        <b>PASAL 14: PENGAKHIRAN PERJANJIAN</b>
      </p>
      <ol type="1">
        <li>
          Ketentuan ini akan berakhir jika terdapat kejadian-kejadian sebagai
          berikut:
          <ol type="a">
            <li>Ketentuan ini berakhir jangka waktunya.</li>
            <li>
              Para Pihak sepakat untuk mengakhiri Ketentuan ini sebelum
              berakhirnya jangka waktu dengan alasan apapun termasuk karena
              terjadinya peristiwa force majeure.
            </li>
            <li>
              Terlepas dari ketentuan lainnya, TELKOMSEL dapat melakukan
              pengakhiran sepihak apabila:
              <ol type="i">
                <li>
                  MERCHANT melakukan pelanggaran atas Ketentuan ini, atau
                  melakukan tindakan yang merugikan, termasuk namun tidak
                  terbatas pada bekerja sama dengan pelaku penipuan (
                  <i>fraudster</i>).
                </li>
                <li>MERCHANT atau penanggung jawabnya dinyatakan pailit.</li>
                <li>
                  Hasil Evaluasi sebagaimana diatur dalam Pasal 6 Ketentuan
                  ditetapkan demikian.
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          Ketentuan ini dapat diperbaharui atau diakhiri dengan kesepakatan Para
          Pihak setiap saat sebelum jangka waktu Ketentuan berakhir.
        </li>
        <li>
          Apabila pada saat berakhirnya Ketentuan ini masih terdapat hak dan
          kewajiban yang belum diselesaikan oleh masing-masing Pihak, maka
          ketentuan-ketentuan dalam Ketentuan ini tetap berlaku dan mengikat
          sampai dengan diselesaikannya hak dan kewajiban tersebut oleh
          masing-masing Pihak.
        </li>
        <li>
          Dengan tetap memperhatikan ayat-ayat lain pada Pasal ini, salah satu
          Pihak berhak memutuskan dan mengakhiri Ketentuan ini jika Pihak yang
          lain terbukti tidak memenuhi tanggung jawab dan kewajiban sebagaimana
          diuraikan dalam Ketentuan ini.
        </li>
        <li>
          Para Pihak sepakat untuk mengesampingkan berlakunya ketentuan Pasal
          1266 KUH Perdata, sehingga sehingga pengakhiran dimaksud dapat
          dilakukan tanpa memerlukan putusan pengadilan dan cukup dilakukan
          dengan pemberitahuan tertulis dari masing-masing Pihak.
        </li>
      </ol>
      <p>
        <b>PASAL 15 : FORCE MAJEURE</b>
      </p>
      <ol type="1">
        <li>
          Tidak dilaksanakannya atau tertundanya pelaksanaan sebagian atau
          keseluruhan ketentuan dari Ketentuan ini oleh salah satu Pihak atau
          Para Pihak tidak termasuk sebagai pelanggaran atas Ketentuan apabila
          hal tersebut disebabkan oleh adanya <i>force majeure</i> (keadaan
          memaksa).
        </li>
        <li>
          Yang termasuk sebagai <i>force majeure</i> adalah kejadian-kejadian
          yang dengan segala daya dan upaya tidak dapat diduga dan tidak dapat
          diatasi oleh Pihak yang mengalaminya, yakni peristiwa-peristiwa
          termasuk namun tidak terbatas pada :
          <ol type="i">
            <li>
              bencana alam termasuk namun tidak terbatas pada banjir, tanah
              longsor, gunung meletus, angin topan dan gempa bumi;
            </li>
            <li>terjangkitnya suatu wabah penyakit menular;</li>
            <li>pemberontakan, huru-hara, kerusuhan, perang;</li>
            <li>kebakaran;</li>
            <li>sabotase;</li>
            <li>embargo dan pemogokan umum;</li>
            <li>
              gangguan terhadap jaringan telekomunikasi, baik terestrial maupun
              ekstra-terestrial (ruas angkasa) karena peristiwa yang terjadi di
              ruang angkasa termasuk teteapi tidak terbatas pada sun-outage,
              gerhana matahari, gangguan astronomi maupun meteorit
            </li>
            <li>
              kebijakan Pemerintah atau instansi yang berwenang yang menghalangi
              secara langsung untuk terlaksananya Ketentuan ini.
            </li>
          </ol>
        </li>
        <li>
          Pihak yang tidak dapat memenuhi kewajibannya sehubungan dengan{' '}
          <i>force majeure</i> tersebut harus memberitahukan secara tertulis
          kepada Pihak lainnya selambat-lambatnya dalam waktu 7 (tujuh) Hari
          Kerja sejak mulainya kejadian tersebut.
        </li>
        <li>
          Kelalaian atau kelambatan Pihak yang terkena <i>force majeure</i>{' '}
          dalam memberitahukan sebagaimana dimaksud pasal ini dapat
          mengakibatkan tidak diakuinya peristiwa dimaksud sebagai{' '}
          <i>force majeure</i>.
        </li>
        <li>
          Semua kerugian dan biaya yang diderita oleh salah satu Pihak sebagai
          akibat <i>force majeure</i> tidak menjadi tanggung jawab Pihak
          lainnya.
        </li>
        <li>
          Jika peristiwa <i>force majeure</i> berkepanjangan hingga 60 (enam
          puluh) hari kalender atau lebih, maka salah satu dari Para Pihak,
          dengan pemberitahuan tertulis kepada Pihak lainnya dapat mengakhiri
          Ketentuan ini tanpa kewajiban-kewajiban lebih lanjut terhadap Pihak
          lainnya yang menyangkut pengakhiran Ketentuan ini, kecuali kewajiban
          pembayaran yang belum diselesaikan selama Ketentuan ini berlangsung.
        </li>
      </ol>
      <p>
        <b>PASAL 16 : HUKUM YANG BERLAKU DAN PENYELESAIAN PERSELISIHAN </b>
      </p>
      <ol type="1">
        <li>
          Ketentuan ini diatur oleh, tunduk pada, dan ditafsirkan berdasarkan
          hukum Republik Indonesia.
        </li>
        <li>
          Dalam hal terjadi perselisihan di antara Para Pihak mengenai
          pelaksanaan Ketentuan ini, maka Para Pihak dengan didasari itikad baik
          sepakat untuk menyelesaikannya terlebih dahulu secara musyawarah untuk
          mufakat.
        </li>
        <li>
          Jika dalam waktu 30 (tiga puluh) hari kalender sejak dimulainya
          penyelesaian sengketa sebagaimana dimaksud ayat (2) Pasal ini tidak
          tercapai mufakat, maka Para Pihak sepakat untuk menyelesaikan
          perselisihan tersebut melalui Badan Arbitrase Nasional Indonesia
          (BANI).
        </li>
      </ol>
      <p>
        <b>PASAL 17 : PEMBERITAHUAN</b>
      </p>
      <ol type="1">
        <li>
          Semua pemberitahuan dan surat menyurat di antara Para Pihak sehubungan
          dengan Ketentuan ini dilakukan secara tertulis dan dianggap telah
          disampaikan kepada Pihak yang bersangkutan bilamana ada tanda terima
          tertulis.
        </li>
        <li>
          Pemberitahuan dan surat menyurat sebagaimana dimaksud dalam ayat (1)
          Pasal ini dialamatkan kepada MERCHANT sebagaimana tertuang dalam
          Formulir Aplikasi MERCHANT dan/atau
          <br />
          <b>TELKOMSEL:</b>
          <br />
          <b>PT. TELEKOMUNIKASI SELULAR</b>
          <br />
          Komplek Telkom Landmark Tower
          <br />
          Tower I (TELKOMSEL Smart Office),
          <br />
          Jl. Jendral Gatot Subroto Kav. 52
          <br />
          Jakarta -12710
          <br />
          Indonesia
          <br />
          Telp. : 021-5240811 <br />
          Fax. : 021-52906133
          <br />
          Up. : Sub Direktorat Mobile Financial Service
        </li>
        <li>
          Masing-masing Pihak wajib segera memberitahukan kepada Pihak lain¬nya
          apabila ada perubahan alamat, nomor telepon dan facsimile melalui pos
          tercatat, facsimile atau telepon. Perubahan alamat akan mulai berlaku
          7 (tujuh) Hari Kalender setelah diterimanya pemberitahuan tersebut.
        </li>
      </ol>
      <p>
        <b>PASAL 18 : PERTENTANGAN KEPENTINGAN</b>
      </p>
      <ol type="1">
        <li>
          Para Pihak sepakat bahwa Pihak yang melakukan penandatanganan
          Ketentuan atau Pemilik dari MERCHANT itu bukan (i) anggota Dewan
          Direksi atau anggota Dewan Komisaris TELKOMSEL (ii) karyawan/wati
          TELKOMSEL (iii) saudara, suami, istri, ipar dari karyawan/wati,
          Direktur, Komisaris TELKOMSEL atau keadaan lain yang dapat menimbulkan
          pertentangan kepentingan.
        </li>
        <li>
          Jika di kemudian hari diketahui bahwa MERCHANT memiliki pertentangan
          kepentingan, maka MERCHANT diwajibkan untuk mengungkapkannya kepada
          TELKOMSEL dan TELKOMSEL mempunyai hak sepenuhnya untuk memutuskan
          Ketentuan secara sepihak apabila transaksi tersebut dipandang tidak
          wajar, dan tidak ada kewajiban bagi TELKOMSEL untuk memberikan ganti
          rugi dalam bentuk apapun sehubungan dengan pemutusan tersebut.
        </li>
      </ol>
      <p>
        <b>PASAL 19 : LARANGAN PEMBERIAN HADIAH DAN KOMISI</b>
      </p>
      <ol type="1">
        <li>
          MERCHANT atau perwakilannya atau agent, atau affiliasi dari MERCHANT
          tidak diperkenankan mengikatkan atau mencoba melakukan pemberian
          hadiah atau komisi kepada pegawai TELKOMSEL.
        </li>
        <li>
          TELKOMSEL dapat mengakhiri Ketentuan, baik seluruhnya maupun sebagian,
          apabila TELKOMSEL berdasarkan alasan yang jelas menemukan bahwa
          MERCHANT, perwakilan atau agen atau affiliasi dari MERCHANT, telah
          bekerjasama atau mencoba untuk bekerjasama dalam rangka pemberian
          hadiah atau komisi kepada pegawai TELKOMSEL.
        </li>
        <li>
          MERCHANT atau pegawai dari MERCHANT dilarang menawarkan, memberikan
          atau setuju untuk memberi hadiah, komisi, rabat, atau bentuk-bentuk
          lainnya kepada pegawai TELKOMSEL yang berkaitan dengan pelaksanaan
          Ketentuan ini.
        </li>
        <li>
          Pelanggaran terhadap ketentuan tersebut Pasal ini oleh MERCHANT atau
          pegawainya atau orang yang bekerja untuknya dapat mengakibatkan
          dibatalkannya Ketentuan ini oleh TELKOMSEL. Pelanggaran terhadap
          ketentuan ini dapat mengakibatkan MERCHANT, sub rekanannya dan atau
          agennya dikenakan tuntutan pidana.
        </li>
      </ol>
      <p>
        <b>PASAL 20 : LAIN-LAIN</b>
      </p>
      <ol type="1">
        <li>
          Ketentuan ini tidak dapat dialihkan oleh salah satu Pihak ke pihak
          ketiga lainnya tanpa persetujuan tertulis terlebih dahulu dari Pihak
          lainnya. Setiap usaha salah satu Pihak untuk mengalihkan suatu hak,
          tugas dan kewajibannya sebagaimana yang telah ditetapkan dalam
          Ketentuan ini tanpa persetujuan dari Pihak lainnya secara tertulis
          adalah tidak sah.
        </li>
        <li>
          Hal-hal yang belum diatur atau belum cukup diatur dalam Ketentuan ini
          akan diatur kemudian berdasarkan kesepakatan Para Pihak yang
          dituangkan ke dalam Addendum/Amandemen terhadap Ketentuan.
        </li>
        <li>
          Dokumen-dokumen lampiran serta Addendum/Amandemen Ketentuan
          sebagaimana tersebut pada ayat (2) Pasal ini merupakan satu kesatuan
          yang tidak dapat dipisahkan dari Ketentuan ini.
        </li>
        <li>
          Setiap judul dalam pasal-pasal Ketentuan ini hanya untuk memudahkan
          pembacaan saja dan dengan demikian tidak mengubah atau memberi arti
          tertentu penafsirannya.
        </li>
        <li>
          Ketentuan ini menggunakan Bahasa Indonesia dan segala hal yang
          berhubungan dengan masalah pembuktian akan dilakukan dalam Bahasa
          Indonesia pula.
        </li>
        <li>
          Biaya-biaya yang dikeluarkan Para Pihak dalam rangka penyusunan
          Ketentuan ini menjadi beban masing-masing Pihak.
        </li>
      </ol>
    </div>
  );
};

export default Indonesia;
